export const FIELD_BORDERLESS_CLASS_NAME =
  "bg-transparent! border-none! rounded-none! px-0! focus:ring-transparent focus:ring-offset-transparent focus-visible:ring-transparent focus-visible:ring-offset-transparent focus-within:ring-transparent focus-within:ring-offset-transparent";

export const FIELD_READ_ONLY_CLASS_NAME = "bg-accent! text-muted-foreground! cursor-not-allowed! pointer-events-none!";
